
import * as React from 'react';
import { IItemCache } from '../../../models/IItemCacheObserver';
import { defaultClickActionControl } from '../../../controls/defaultClickActionControl';
import { openDefaultClickActionHandler } from './handlers/open';
import { openUrlDefaultClickActionHandler } from './handlers/openUrl';
import { IActionInput, renderAction, evaluateAction } from '../../withAction/WithAction';
import { connectToItemCache } from '../../decorators/connectToItemCache';

/**
 * @public
 */
export interface IDefaultClickActionHandlerProps {
    itemKey: string;
}

/**
 * @public
 */
export interface IDefaultClickActionHandler {
    key: string;
    /**
     * Evaluates whether the handler applies to the given item,
     * and returns an action only if it does.
     */
    evaluate(itemCache: IItemCache, props: IDefaultClickActionHandlerProps): {
        action?: IActionInput;
    };
}

const HANDLERS: IDefaultClickActionHandler[] = [openDefaultClickActionHandler, openUrlDefaultClickActionHandler];

/**
 * @public
 */
export interface ISelectedActionProps {
    action?: IActionInput;
}

/**
 * @public
 */
export interface IItemDefaultClickActionProps {
    itemKey: string;
}

/**
 * @public
 */
export const ItemDefaultClickAction: React.ComponentType<IItemDefaultClickActionProps> =
    connectToItemCache((itemCache: IItemCache, props: IItemDefaultClickActionProps): ISelectedActionProps => {
        const controlHandler = itemCache.demandItemFacet(defaultClickActionControl, props.itemKey);

        const {
            handlers
        } = defaultClickActionControl.evaluate(controlHandler)(itemCache, {
            itemKey: props.itemKey,
            handlers: HANDLERS
        });

        let action: IActionInput | undefined;

        for (const handler of handlers) {
            const {
                action: handlerAction
            } = handler.evaluate(itemCache, props);

            if (handlerAction) {
                action = handlerAction;
                break;
            }
        }

        return {
            action: evaluateAction(itemCache, action)
        };
    })((props: ISelectedActionProps): JSX.Element | null => {
        return renderAction(props.action);
    });
